module.exports = __webpack_public_path__ + "static/img/2.17b3ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/2.png
// module id = ZXfF
// module chunks = 1